import * as React from "react";

const BadgeSchedulingUnavailable: React.FC = () => {
    return (
        <svg
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M8,16 C10.8581251,16 13.4991411,14.4752083 14.9282039,12 C16.3572658,9.52479172 16.3572658,6.47520876 14.9282039,4 C13.4991411,1.52479172 10.8581251,0 8,0 C5.14187562,0 2.50085914,1.52479172 1.07179677,4 C-0.357265592,6.47520876 -0.357265592,9.52479172 1.07179677,12 C2.50085914,14.4752083 5.14187562,16 8,16 Z M8.75000036,4 L8.75000036,4.75 L8.75000036,8.25 L8.75000036,9 L7.25000036,9 L7.25000036,8.25 L7.25000036,4.75 L7.25000036,4 L8.75000036,4 Z M7.25000036,11.5 L7.25000036,10 L8.75000036,10 L8.75000036,11.5 L7.25000036,11.5 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(BadgeSchedulingUnavailable);
